import { ABOUT, PROFILE } from '@constants/routes';

export type SidebarUserProfileNavigationItem = {
    label: string;
    route: string;
    icon: string;
    iconColor: string;
    iconBackgroundColor: string;
};

export const sidebarUserProfileNavigationItems: Array<SidebarUserProfileNavigationItem> = [
    {
        label: 'Profile Settings',
        route: PROFILE,
        icon: 'br-icon:person',
        iconColor: '#818cf8',
        iconBackgroundColor: 'rgba(129,140,248,0.15)'
    },
    {
        label: 'About',
        route: ABOUT,
        icon: 'br-icon:info',
        iconColor: '#818cf8',
        iconBackgroundColor: 'rgba(129,140,248,0.15)'
    }
];
